export enum ErrorCodes {
  UnknownError,
  MaxGasLimit,
  InsufficientBalance,
  MinimalFee,
  DataEntryNotFound,
}
